// extracted by mini-css-extract-plugin
module.exports = {"center":"style_center__1tTj-","pagination":"style_pagination__1jSJK","active":"style_active__2x4iB"};